import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Perks = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0c.851 0 1.625.495 1.981 1.268l1.951 4.23 4.625.548a2.182 2.182 0 0 1 1.224 3.768l-3.419 3.162.908 4.568a2.182 2.182 0 0 1-3.206 2.33L24 17.598l-4.064 2.274a2.182 2.182 0 0 1-3.206-2.329l.908-4.568-3.42-3.162a2.182 2.182 0 0 1 1.225-3.768l4.625-.549 1.95-4.229A2.182 2.182 0 0 1 24 0Zm-2.462 7.52-5.838.692 4.316 3.992-1.146 5.766L24 15.098l5.13 2.872-1.146-5.766L32.3 8.212l-5.838-.692L24 2.182 21.538 7.52ZM.526 25.699l7.11 4.299V36c0 .352.17.683.457.888l15.252 10.894a1.09 1.09 0 0 0 1.295.01l15.267-10.904a1.09 1.09 0 0 0 .457-.888v-6.002l7.11-4.3a1.09 1.09 0 0 0 .003-1.864l-12-7.311a1.091 1.091 0 0 0-1.135 1.863l3.57 2.175L24 28.525l-13.912-7.964 3.57-2.175a1.09 1.09 0 0 0-1.135-1.863l-12 7.31A1.09 1.09 0 0 0 .526 25.7Zm37.656 5.618-6.111 3.695a1.09 1.09 0 0 1-1.107.014L24 31.038l-6.964 3.986a1.091 1.091 0 0 1-1.107-.013l-6.11-3.695v4.122l13.09 9.35V36a1.09 1.09 0 1 1 2.182 0v8.79l13.09-9.351v-4.122ZM7.96 21.857l13.844 7.925-5.295 3.031-13.316-8.051 4.767-2.904Zm23.531 10.956-5.295-3.03 13.843-7.925 4.767 2.904-13.315 8.051Z"
  }));
});
Perks.displayName = 'Perks';
Perks.defaultProps = {
  'aria-label': 'Perks'
};
export default Perks;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Perks.js
// module id = 3240
// module chunks = 11